import React, { useRef } from "react";
import Footer from "./footer";
import Contact from "../pages/contact";
import OurTeam from "../pages/ourTeam";
import About from "../pages/about";
import Header from "./header";

export default function Home() {
  const scrollToSection = (id) => {
    console.log(`Scrolling to ${id}`);
    const element = document.querySelector(`[data-section='${id}']`);
    // const element = document.getElementById(id);
    if (element) {
      console.log(`Found element:`, element);

      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div>
      <Header navLink={scrollToSection} />
      <div data-section="about">
        <About />
      </div>
      <div data-section="team">
        <OurTeam />
      </div>
      <div data-section="contact">
        <Contact />
      </div>

      <Footer navLink={scrollToSection} />
    </div>
  );
}
